import React from 'react';
import TrafalgarLogo from './TrafalgarLogo';

const MobileMenuButton = ({ onClick }) => {
  return (
    <button 
      className="mobile-menu-btn" 
      onClick={onClick} 
      aria-label="Open menu"
    >
      <div style={{ width: '24px', height: '24px' }}>
        <TrafalgarLogo />
      </div>
    </button>
  );
};

export default MobileMenuButton;
